import { render, staticRenderFns } from "./ProductInfoList.vue?vue&type=template&id=79e03963&scoped=true&"
import script from "./ProductInfoList.vue?vue&type=script&lang=js&"
export * from "./ProductInfoList.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoList.vue?vue&type=style&index=0&id=79e03963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e03963",
  null
  
)

export default component.exports